import { useMutation, useQueryClient } from "@tanstack/react-query"
import { isNetworkError } from "@/shared/api/errors"
import { retryNetwork } from "@/shared/config/query"
import { userKeys } from "../model/keys"
import { deleteUserAccount, updateUser } from "./client"

export function useUpdateUser() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: updateUser,
		retry: retryNetwork,
		onSuccess: (data) => {
			queryClient.setQueryData(userKeys.byId(data.id), data)
		},
	})
}

export function useDeleteUserAccount() {
	return useMutation({
		mutationFn: ({ id, reason }: { id: number; reason: string }) =>
			deleteUserAccount(id, reason),
		retry: (failureCount, error) => isNetworkError(error) && failureCount < 1,
	})
}
